// Packages
import tw, { styled } from "twin.macro";

// Images
// import Amex from "../../_images/amex.png";
import Amex from "../../_images/bluebox.svg";

export const Container = styled.footer(() => [
  ``,
  tw`justify-center flex flex-col items-center box-content container mx-auto mt-14 pb-14 md:pb-20 border-t border-gray-300 relative lg:mt-20`
]);

export const Disclaimer = styled.div(({ isJP }) => [
  `a:link, a:visited, a:hover, a:focus, a:active { text-decoration: underline; }`,
  `p{margin-bottom:1rem;text-wrap:pretty;}`,
  tw`text-copy text-gray-700 px-4 text-center max-w-4xl`
]);

export const Logo = styled.div(() => [
  `background-image: url("${Amex}"); width:48px; height:48px; background-size: 48px 48px;`,
  tw`bg-center bg-contain bg-no-repeat mx-auto mt-4 block md:mt-0 py-12`
]);
